/** V146 (IMPRESION) — tipos compartidos del carril de impresión (front). */

export type PaperWidth = 58 | 80;
export type PrinterRole = 'caja' | 'cocina' | 'barra';
export type PrinterBackend = 'qz' | 'network' | 'browser';

/** Espejo de la entidad `printers` del backend (serializa camelCase). */
export interface Printer {
  id: string;
  tenantId: string;
  branchId: string | null;
  name: string;
  role: PrinterRole;
  backendKind: PrinterBackend;
  paperWidth: number;
  qzPrinterName: string | null;
  netHost: string | null;
  netPort: number | null;
  isActive: boolean;
  sortOrder: number;
}

/** Tipo de documento → ROL de impresora al que se rutea (mapa por defecto). */
export type DocKind = 'ticket' | 'comanda' | 'corte' | 'cancel';
export const DOC_ROLE: Record<DocKind, PrinterRole> = {
  ticket: 'caja',
  comanda: 'cocina',
  corte: 'caja',
  cancel: 'caja',
};

export const ROLE_LABEL: Record<PrinterRole, string> = {
  caja: 'Caja', cocina: 'Cocina', barra: 'Barra',
};
export const BACKEND_LABEL: Record<PrinterBackend, string> = {
  qz: 'QZ Tray (escritorio, silencioso)',
  network: 'Red / ePOS (silencioso, multiplataforma)',
  browser: 'Navegador (universal, con diálogo)',
};
